// extracted by mini-css-extract-plugin
module.exports = {"paperRoot":"Dialog_paperRoot__25Jf6","playbarRelatedLayer":"Dialog_playbarRelatedLayer__Rcj37","playbarRelatedMargin":"Dialog_playbarRelatedMargin__2tk2c"};